import type { SVGProps } from "react";
export interface CloudWeatherBoltIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CloudWeatherBoltIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CloudWeatherBoltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 10a2.88 2.88 0 0 0-2.158-2.785 1.125 1.125 0 0 1-.843-1.135l.001-.08a1.875 1.875 0 0 0-3.003-1.498 1.125 1.125 0 0 1-1.538-.173 3.375 3.375 0 0 0-5.918 2.704c.084.532-.22 1.05-.727 1.234a2.377 2.377 0 0 0 .81 4.608h1.026l.114.006a1.126 1.126 0 0 1 0 2.238l-.114.006H6.5a4.625 4.625 0 0 1-2.375-8.593V6.5a5.625 5.625 0 0 1 9.256-4.295 4.12 4.12 0 0 1 5.68 3.101 5.126 5.126 0 0 1-1.798 9.812l-.264.007h-.998a1.125 1.125 0 0 1 0-2.25h.998l.295-.015A2.876 2.876 0 0 0 19.875 10"
      />
      <path
        fill={color}
        d="M13.006 22.503a1.124 1.124 0 0 1-2.013-1.006zm-2.013-9.005a1.125 1.125 0 1 1 2.013 1.005l-1.187 2.372H14a1.125 1.125 0 0 1 1.007 1.628l-2.001 4L11.999 22l-1.006-.503 1.187-2.372H10a1.125 1.125 0 0 1-1.006-1.628z"
      />
    </svg>
  );
}
